import { Alert, Box, Button, Card, Group, Modal, Stack, Text, TextInput } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconDeviceFloppy } from "@tabler/icons-react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks";
import { getProjectIdFromUrl } from "../../../utils";
import { useCreateMeetingSerieMutation } from "../meetingSerieRTK";
import { setClickedMeetingSerieIdInRedux } from "../meetingSlice";

const NewMeetingSeriesModal: React.FC<{
  opened: boolean;
  onClose: () => void;
}> = ({ opened, onClose }) => {
  const [seriesStart, setSeriesStart] = useState<Date | null>(new Date());
  const [name, setName] = useState<string>("");

  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const dispatch = useAppDispatch();
  const [createMeetingSerie, { isError: createMeetingError }] = useCreateMeetingSerieMutation();

  const onCreate = async () => {
    if (!seriesStart) return;
    const resp: any = await createMeetingSerie({
      projectId: projectId,
      name: name,
      seriesStart: seriesStart.toISOString(),
    });
    dispatch(setClickedMeetingSerieIdInRedux(resp.data._id));
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Ny møteserie" size="md" padding="md" yOffset={140} radius="md">
      <Card p="sm" bg="#fafafb" bd="1px solid var(--mantine-color-warmgray-2)">
        <Stack gap="sm">
          {createMeetingError && (
            <Alert color="red" variant="light" title="Feil">
              Kunne ikke opprette møteserien. Prøv igjen.
            </Alert>
          )}
          <TextInput
            label="Navn på møteserie"
            placeholder="Skriv inn navn for møteserie"
            value={name}
            autoFocus
            onChange={(e) => setName(e.currentTarget.value)}
          />
          <Box>
            <Text size="md" fw={500} mb="xs">
              Startdato
            </Text>
            <DateInput
              size="md"
              maw={200}
              placeholder="Velg startdato"
              value={seriesStart}
              clearable
              valueFormat="YYYY-MM-DD"
              onChange={(d) => {
                if (!d) return setSeriesStart(null);
                setSeriesStart(typeof d === "string" ? new Date(d) : d);
              }}
              popoverProps={{ withinPortal: true }}
            />
          </Box>

          <Group justify="flex-end">
            <Button
              leftSection={<IconDeviceFloppy size={16} />}
              color="mc-primary"
              variant="filled"
              disabled={!seriesStart || name.trim() === ""}
              onClick={onCreate}
            >
              Opprett
            </Button>
          </Group>
        </Stack>
      </Card>
    </Modal>
  );
};

export default NewMeetingSeriesModal;
